/**
 * Created by mateimisarca on 29/11/2019
 */

import VerifyAccount from './verify-account';

export default VerifyAccount;
